import { createSlice } from "@reduxjs/toolkit";
import {
  addProduct,
  fetchProducts,
  fetchProductById,
  updateProduct,
  updateStatusInProduct,
  fetchProductsByDropDown,
  fetchProductsDropDownByModel,
} from "./thunk";

interface ProductsAndServicesState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedProduct: any;
  categories: any[];
  subcategories: any[];
  makes: any[];
  models: any[];
  fetchProductsAndServicesBasedOnModel:any[];
  fetchModel:any[];
}

const initialState: ProductsAndServicesState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedProduct: null,
  categories: [],
  subcategories: [],
  makes: [],
  models: [],
  fetchProductsAndServicesBasedOnModel:[],
  fetchModel:[]
};

const productsSlice = createSlice({
  name: "product",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
     .addCase(fetchProductsByDropDown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsByDropDown.fulfilled, (state, action) => {
        console.log(action.payload, "line no 38 in action reduer")
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProductsByDropDown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Products and Services";
      })
      .addCase(fetchProductsDropDownByModel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsDropDownByModel.fulfilled, (state, action) => {
        state.loading = false;
        state.fetchProductsAndServicesBasedOnModel = action.payload.data;
      })
      .addCase(fetchProductsDropDownByModel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch products by model";
      })
        .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        console.log(action.payload, "line no 38 in action reduer")
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Products and Services";
      })
      .addCase(fetchProductById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedProduct = action.payload;
      })
      .addCase(fetchProductById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProduct.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(addProduct.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.list = state.list.map((product) =>
          product.id === action.payload.id ? action.payload : product
        );
      })
      .addCase(addProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })

      .addCase(updateStatusInProduct.pending, (state) => {
        state.loading = true
      })
      .addCase(updateStatusInProduct.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
      })
      .addCase(updateStatusInProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      })
  },
});

export default productsSlice.reducer;
